import React, { Component } from "react";
import { Container, Row, Col } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb';
import GetInTouchEmails from './getInTouch';

class GetInTouch extends Component {
    constructor(props) {
        super(props);
        this.state = {
            breadcrumbItems : [
                { title : "Minimis", link : "/" },
                { title : "Get In Touch", link : "#" },
            ],
        }
    }

    render() {
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>

                    <Breadcrumbs title="" breadcrumbItems={this.state.breadcrumbItems} />
                        <Row>
                               <GetInTouchEmails/>
                        </Row>

                    </Container> 
                </div>
            </React.Fragment>
        );
    }
}

export default GetInTouch;
